import React, { forwardRef, useState, useEffect } from "react";
import CategoryItem from "./CategoryItem";
// import ExampleMenu from "./exampleMenu.json";

interface MenuCategoryProps {
  // add any props here
  classes: string;
  list: any[];
}

const MenuCategory = forwardRef<HTMLDivElement, MenuCategoryProps>(
  ({ classes, list }, ref) => {
    const [hoveredCategory, setHoveredCategory] = useState(null);
    const [hoveredCategorySubCategory, setHoveredCategorySubCategory] =
      useState(null);

    return (
      <div ref={ref} className={classes}>
        <div style={{ position: "relative" }}>
          {list.map((category) => {
            return (
              <CategoryItem
                key={category.categoryId}
                onMouseEnter={() => setHoveredCategory(category.categoryId)} // Set the hovered category on mouse enter
                onMouseLeave={() => setHoveredCategory(null)} // Reset the hovered category on mouse leave
                onMouseEnterSubCategory={(id) =>
                  setHoveredCategorySubCategory(id)
                } // Set the hovered category on mouse enter
                onMouseLeaveSubCategory={() =>
                  setHoveredCategorySubCategory(null)
                } // Reset the hovered category on mouse leave
                hoveredCategory={hoveredCategory}
                hoveredCategorySubCategory={hoveredCategorySubCategory}
                {...category}
              />
            );
          })}
        </div>
      </div>
    );
  }
);

export default MenuCategory;
